module.exports = "/_next/static/images/isms-logo-45e686dac529170366742afe802bf02d.png";